<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    :viewBox="'0 0 ' + size + ' ' + size"
  >
    <defs>
      <filter id="6n1t0a9goa">
        <feColorMatrix
          in="SourceGraphic"
          values="0 0 0 0 0.576471 0 0 0 0 0.576471 0 0 0 0 0.576471 0 0 0 1.000000 0"
        />
      </filter>
    </defs>
    <g fill="none" fill-rule="evenodd">
      <g>
        <g
          filter="url(#6n1t0a9goa)"
          transform="translate(-998.000000, -276.000000) translate(81.000000, 253.000000)"
        >
          <g>
            <path
              :fill="color"
              fill-rule="nonzero"
              d="M8 .667c4.05 0 7.333 3.283 7.333 7.333 0 4.05-3.283 7.333-7.333 7.333C3.95 15.333.667 12.05.667 8 .667 3.95 3.95.667 8 .667zm0 1C4.502 1.667 1.667 4.502 1.667 8S4.502 14.333 8 14.333 14.333 11.498 14.333 8 11.498 1.667 8 1.667zm0 1.066c.306 0 .558.23.595.525l.005.075v4.348l2.267 2.193c.218.21.242.548.067.786l-.053.062c-.21.218-.548.242-.786.067l-.062-.053L7.4 8.19V3.333c0-.331.269-.6.6-.6z"
              transform="translate(917.000000, 23.000000)"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export class IconTime extends Vue {
  @Prop({ default: 26 }) public size!: number;
  @Prop({ default: "#ffffff" }) public color!: string;
}
export default IconTime;
</script>
